<template>
  <div>
    <h1>
      Scanner un kanban
    </h1>
    <br>
    <SelectWorkstation :loop="selectedLoop"></SelectWorkstation>
    <ScanetteInput v-show="bus.currentStep" @new-scan="selectCode"></ScanetteInput>
    <transition :duration="{ enter: 2000, leave: 2000 }">
      <div class="scanned-card" v-if="selectedLoop && kanbanNumber">
        <AndonCard
          @click.native="goTo('/andon/'+kanbanId)"
          :andon="andon"
        ></AndonCard>
        <KanbanCard
          :kanbanId="kanbanId"
          :cardDesignation="cardDesignation"
          :batchSize="batchSize"
          :cardIndex="cardIndex"
          :nbCard="nbCard"
          :emplacement="emplacement"
          :supplier="supplier"
          :supplierCode="supplierCode"
          :weight="weight"
          :kanbanNumber="kanbanNumber"
        ></KanbanCard>
        <kanban-card-details
          :supplier="supplier"
          :noScanSince="noScanSince"
          :deliveryDate="deliveryDate"
          :lastBL="lastBL"
        ></kanban-card-details>
      </div>
    </transition>
  </div>
</template>
<script>
import server from '../../api/server.vue'
import erpLoaderServer from '../../api/erp_loader_server.vue'
import { Steps } from '../../core/services/steps.js'
import { bus } from '../../core/utils/bus.js'
import SelectWorkstation from '../kanban/SelectWorkstation.vue'
import ScanetteInput from '../kanban/ScanetteInput.vue'
import AndonCard from './detailed/AndonCard.vue'
import KanbanCard from '../kanban/KanbanCard.vue'
import KanbanCardDetails from '../kanban/KanbanCardDetails.vue'
import moment from 'moment'


export default {
  name: 'ScanKanbanWorkstation',
  data() {
    return {
      bus: bus,
      filter: null,
      selectedLoop: null,
      andon: null,
      kanbanId: null,
      scan: null,
      lastScan: null,
      cardRemoved: null,
      refRemoved: null,
      cardDesignation: null,
      batchSize: 0,
      cardIndex: 0,
      kanbanNumber: null,
      supplier: null,
      supplierCode: null,
      weight: null,
      nbCard: null,
      kanbanId: null,
      noScanSince: null,
      emplacement: null,
      lastBL: null,
    }
  },
  components : {
    SelectWorkstation,
    AndonCard,
    KanbanCard,
    ScanetteInput,
    KanbanCardDetails,
  },
  methods: {
    getBLRef (kanbanRef) {
    erpLoaderServer
      .getBlFromRef(kanbanRef)
      .then(res => {
        if (res) {
          res = res.data
          this.lastBL = res[0] //.command_date
          // this.deliveryDate = res[0].delivery_date
        }
      })
      .catch(err => {
        console.log(err)
      })
    },
    getAndonLowStock () {
      server.getAndonLowStockForRef(this.kanbanId).then(result => {
        result = result.data
        if (Array.isArray(result.andon) && result.andon.length) {
          const position = result.andon.length - 1
          this.lowStockItem = result.andon[position]
          var value = this.lowStockItem.card_in_stock + '/' + this.lowStockItem.card_in_total
          // this.$store.commit('setAndons', { andonName: 'Stock faible', andonValue: value })
          this.andon = true
        }
      })
    },
    getAndonUnseenCard () {
      server.getUnseenCardAndonFromCard(this.kanbanNumber).then(result => {
        result = result.data
        if (Object.keys(result.andon).length !== 0 && result.andon.constructor === Object) {
          this.unseenItem = result.andon
          // this.$store.commit('setAndons', { andonName: 'Retard', andonValue: this.unseenItem })
          this.andon = true
        }
      })
    },
    /*getAndonFifo () {
      server.getFifoAndonFromCard(this.kanbanNumber).then(result => {
        result = result.data
        if (Array.isArray(result.andon) && result.andon.length) {
          const position = result.andon.length - 1
          this.fifoItem = result.andon[position]
          var value = this.fifoItem.andon_scan.kanban_card.card_index + ' vu avant ' + this.fifoItem.previous_scan.kanban_card.card_index
          // this.$store.commit('setAndons', { andonName: 'Fifo', andonValue: value })
          this.andon = true
        }
      })
    },*/
    getAndonBadErpStock () {
      server.getAndonBadErpStockForRef(this.kanbanId).then(result => {
        result = result.data
        if (Array.isArray(result.andon) && result.andon.length) {
          const position = result.andon.length - 1
          this.erpStockItem = result.andon[position]
          var value = this.erpStockItem.erp_stock + '/' + this.erpStockItem.kanban_stock
          // this.$store.commit('setAndons', { andonName: 'Ecart stock ERP', andonValue: value })
          this.andon = true
        }
      })
    },
    getAndons () {
      this.getAndonLowStock()
      this.getAndonUnseenCard()
      this.getAndonBadErpStock()
    },
    updateLastScanInfo (scan) {
      this.scan = scan
      this.cardRemoved = scan.removed
      this.refRemoved = scan.kanban_reference.removed
      this.cardDesignation = scan.kanban_reference.reference.designation
      this.batchSize = scan.kanban_reference.batch_size
      this.cardIndex = scan.card_index
      this.kanbanNumber = scan.card_id
      this.supplier = scan.kanban_reference.supplier
      this.supplierCode = scan.kanban_reference.supplier_code
      this.weight = scan.kanban_reference.weight
      this.nbCard = scan.kanban_reference.nbr_card
      this.kanbanId = scan.kanban_reference.reference.code
      this.noScanSince = Math.round(scan.seconds_since_last_scan / 86400)
      if (scan.kanban_reference.reference.pos_y &&
        scan.kanban_reference.reference.pos_z) {
        this.emplacement =
          scan.kanban_reference.reference.zone +
          scan.kanban_reference.reference.pos_y.toString() +
          this.padStrg(scan.kanban_reference.reference.pos_x, 2) +
          scan.kanban_reference.reference.pos_z.toString()
      } else {
        this.emplacement = ''
      }
      this.getBLRef(this.kanbanId)
      this.getAndons()
      // if (scan.andonSpeed !== '') {
      //   // this.$store.commit('setAndons', { andonName: 'Vitesse', andonValue: scan.andonSpeed })
      // }
    },
    selectCode (code) {
      this.kanbanNumber = code
      server.getLastKanbanCardId(code).then(result => {
        result = result.data
        result.last.kanban_card.andonSpeed = this.andonSpeedState
        // this.$store.commit('setKanbanInfo', result.last.kanban_card)
        this.lastScan = result.last
        this.updateLastScanInfo(result.last.kanban_card)
      })
      .catch(err => {
        console.log(err)
        // this.hasError('Dernière carte non trouvée.')
      })
    },
  },
  mounted: function() {
    // bus.currentStep = Steps[this.$route.params.step]
    if (this.$route.params.code) {
      this.selectCode(this.$route.params.code)
    }
    server.getLoops().then((result) => {
       result.data.forEach(loop => {
        if (loop.name == 'loop_external') {
          this.selectedLoop = loop
        }
      })
    })
  }

}
</script>



// WEBPACK FOOTER //
// src/components/andon/ScanKanbanWorkstation.vue